import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=5c829ea4&scoped=true"
import script from "./orderDetail.js?vue&type=script&lang=js&external"
export * from "./orderDetail.js?vue&type=script&lang=js&external"
import style0 from "./orderDetail.scss?vue&type=style&index=0&id=5c829ea4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c829ea4",
  null
  
)

export default component.exports